export default __webpack_public_path__ + "static/media/img_6.e932b925.jpeg";